module.exports = __webpack_public_path__ + "img/lib_region_flag_ai.03a3727a.png";